<template>
    <vs-popup classContent="popup-example" :title="translate('AddKey')" :active.sync="popUps.popupAddActive">
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-input class="inputx w-full" :label="translate('Name')" v-model="formParams.pageName" :readonly="formParams.formType==='edit'" />
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-input class="inputx w-full" :label="translate('URL')" v-model="formParams.pageUrl" />
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-input class="inputx w-full" :label="translate('Title')" v-model="formParams.pageTitle" />
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-input class="inputx w-full" :label="translate('Description')" v-model="formParams.pageDescription" />
        </div>
      </div>      
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-button @click="submitForm()" color="primary" type="filled">{{translate('Save')}}</vs-button>
        </div>
      </div>
    </vs-popup>
</template>
<script>
import axios from "@/axios.js"
export default {
    props:['closePopups','formParams','popUps','openAlert'],
    data() {
        return {}
    },
    methods:{
      translate: function(key){
        return this.$t(key);
      },
      submitForm: function(){
        let that = this;
        this.$validator.validateAll().then(result => {
          if(result) {
            if(that.formParams.formType=='add')
              that.addData();
            else
              that.updateData();
          }
        })
      },
      addData: function(){
        let that = this;
        this.$vs.loading();
        axios.post("https://crm.evblock.com/api/seo",this.formParams)
        .then((data) => {
          that.$vs.loading.close();
          if(data.data.success){
            that.closePopups();
            that.openAlert('success','Success');
            that.componentKey++;
          } else{
            that.openAlert('danger','Failed',data.data.Message);
          }
        })
      .catch(() => { that.$vs.loading.close(); that.openAlert('danger','Failed'); })
    },
    updateData: function(){
      let that = this;
      this.$vs.loading();
      axios.put("https://crm.evblock.com/api/seo",this.formParams)
      .then((data) => {
        that.$vs.loading.close();
        if(data.data.success){
          that.closePopups();
          that.openAlert('success','Success');
          that.componentKey++;
        } else{
          that.openAlert('danger','Failed',data.data.Message);
        }
        })
      .catch(() => { that.$vs.loading.close(); that.openAlert('danger','Failed'); })
    },
    }
}
</script>